export default __webpack_public_path__ + "static/media/vending-machine-2.bba5b72b.svg";